import type { Plugin } from './plugin'
import { State } from './state'

/**
 * Selectors for space lite record functional usage state.
 */
export class Selectors {
  /** Methodology as last loaded from the backend */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly methodology

  /** Methodology the user edited to, if they edited it at all */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly editedMethodology

  /** Whether the methodology differs from what was last loaded from the backend */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly hasChanged

  /** Whether a functional usage request is in flight */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /** Error from the last functional usage request, if there was one */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin) {
    this.error = plugin.feature.state.project(state => state.error)
    this.methodology = plugin.feature.state.project(state => state.methodology)
    this.editedMethodology = plugin.feature.state.project(
      state => state.editedMethodology,
    )
    this.hasChanged = plugin.feature.state.project(State.hasChanged)
    this.isLoading = plugin.feature.state.project(state => state.isLoading)
  }
}
